import './assets/sass/main.sass'
import $ from 'jquery'
$(document).ready(function () {
  $('.contacts-button').click(function () {
    $('#contact-modal').fadeIn()
    document.body.classList.add('body_clipped')
  })
  $('.modal__close').click(function () {
    $(this).parents('.modal').fadeOut()
    document.body.classList.remove('body_clipped')
  })
  $('#feedback-modal').submit(function (e) {
    e.preventDefault()
    $('#contact-form-submit').addClass('button_loading')
    let form = $(this)
    let actionUrl = form.attr('action')
    let data = {
      name: $('#contact-form__name').val(),
      about: $('#contact-form__about').val(),
      email: $('#contact-form__email').val(),
      number: $('#contact-form__number').val(),
      attachments: []
    }
    window.grecaptcha.ready(function () {
      window.grecaptcha.execute('6LerLy8nAAAAAN0vedQRA4S9F9fd852TIY0Lk2Oh', {action: 'submit'}).then(function (token) {
        data.token = token
        fetch(actionUrl, {
          method: 'POST',
          mode: 'cors',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(data)
        }).then((response) => {
          if (response.status !== 200) {
            throw new Error(response)
          }
          $('#contact-form-submit').removeClass('button_loading')
          $('#contact-form-submit').addClass('button_sent')
          $('#contact-form-submit').html('Done')
          $('#contact-form__name').val('')
          $('#contact-form__about').val('')
          $('#contact-form__email').val('')
          $('#contact-form__number').val('')
          setTimeout(() => {
            $('#contact-form-submit').removeClass('button_sent')
            $('#contact-form-submit').html('Submit')
          }, 2000)
          return response
        }).catch(() => {
          $('#contact-form-submit').removeClass('button_loading')
        })
      })
    })
  })
  $('#nav__menu-button').click(function () {
    $('#nav').toggleClass('nav_active')
    $('body').toggleClass('body_clipped')
  })
  $('#main-page-get-in-touch-button').click(function () {
    $('html, body').animate({
      scrollTop: $('#main-page-get-in-touch').offset().top
    }, 1000)
  })
})



// WEBPACK FOOTER //
// ./src/main.js